module.exports = __webpack_public_path__ + "static/media/squared.c43b935a.jpg";